import {useQuery} from "@tanstack/react-query";
import {useAxios} from "../../hooks/axios/useAxios";
import {stripeCartUrl} from "../../constants/api/endpoints";

export const useQueryCart = ({portfolio_id, payment_intent_id}: {portfolio_id?: string | null, payment_intent_id?: string}) => {
  const axios = useAxios();

  const handleRequest = () => {
    if (portfolio_id && payment_intent_id) {
      return axios.get(stripeCartUrl, {
        params: {
          portfolio_id,
          payment_intent_id
        }
      })
        .then(response => response?.data ?? response);
    }
    return null;
  }

  return useQuery({
    queryKey: ['cart', portfolio_id, payment_intent_id],
    queryFn: handleRequest,
  })

}
